/* eslint-disable @typescript-eslint/no-explicit-any */
import Styles from "./layout.module.scss";
import AirbusLogo from "../../assets/images/SVG/airbusLogo.svg";
import FlowWise from "../../assets/images/SVG/flowWise.svg";
import { Avatar, Col, Dropdown, notification, Row } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { useMutation } from "@tanstack/react-query";
import { logOut } from "./mutations";
import NotificationPanel from "../notifications/NotificationPanel";

const Header = () => {
  // global
  const navigate = useNavigate();
  const cookies = new Cookies();
  const userName = cookies?.get("userName");
  const currentRole = cookies?.get("currentRole");

  const logoutMutate = useMutation({
    mutationFn: () => logOut(),
    onSuccess: async () => {
      localStorage.clear();
      sessionStorage.clear();
      const allCookies = cookies?.getAll();
      delete allCookies.credentials;
      Object?.keys(allCookies)?.map((i) => {
        cookies?.remove(i);
      });
      navigate("/");
    },
    onError: (error: any) => {
      localStorage.clear();
      sessionStorage.clear();
      const allCookies = cookies?.getAll();
      delete allCookies.credentials;
      Object?.keys(allCookies)?.map((i) => {
        cookies?.remove(i);
      });
      navigate("/");
      notification.error({
        message: error?.response?.data?.detail,
      });
    },
  });

  // dropdown menu items
  const items = [
    {
      key: "1",
      label: "Logout",
      onClick: () => logoutMutate?.mutate(),
    },
  ];

  return (
    <div className={Styles.headerContainer}>
      <div className={Styles.insideContainer}>
        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <img src={AirbusLogo} alt="airbusLogo" height={17} />
            <span style={{ fontWeight: 700, fontSize: "14px", color: "#fff" }}>ALOS</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <img src={FlowWise} alt="flowWiseLogo" height={30} />
          </div>
        </div>

        <Row gutter={8} align="middle" style={{ flexWrap: "nowrap" }}>
          <Col style={{ textAlign: "right", minWidth: 0, overflow: "hidden" }}>
            <b style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: "13px" }}>{userName}</b>
            <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: "11px" }}>{currentRole}</div>
          </Col>
          <Col flex="none">
            <NotificationPanel />
          </Col>
          <Col flex="none">
            <Dropdown menu={{ items }} placement="bottomRight" arrow>
              <Avatar icon={<UserOutlined />} size="default" />
            </Dropdown>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Header;
